import { getCookie } from 'cookies-next';
import { IncomingMessage } from 'http';
import { localStorageKeys } from 'utils/constants';

const givingKeys = [
  localStorageKeys.GIFT_AMOUNT,
  localStorageKeys.GIFT_CURRENCY,
  localStorageKeys.GIFT_FREQUENCY,
  localStorageKeys.GIFT_FUND,
  localStorageKeys.GIFT_PAYMENT_DATE,
  localStorageKeys.GIFT_PAYMENT_DATE,
  localStorageKeys.LAST_GIFT_PAYMENT_METHOD,
  localStorageKeys.GIFT_PAYMENT_METHOD,
  localStorageKeys.GIFT_PAYMENT_METHOD,
  localStorageKeys.EDIT_SCHEDULED_GIFT_PAYMENT_METHOD,
  localStorageKeys.EDIT_SCHEDULED_GIFT_PAYMENT_METHOD,
  localStorageKeys.EDIT_SCHEDULED_GIFT,
  localStorageKeys.EDIT_SCHEDULED_GIFT,
  localStorageKeys.SCHEDULE_ONE_TIME,
  localStorageKeys.SCHEDULE_ONE_TIME,
];

interface Props {
  req: IncomingMessage;
}

export async function mapGivingData({ req }: Props) {
  const get = (key: string) => getCookie(key, { req }) || null;

  return {
    givingData: givingKeys.reduce((map: { [key: string]: string | boolean | null }, key) => {
      map[key] = get(key);
      return map;
    }, {}),
  };
}
